<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-card>
          <v-card-title class="justify-center"
            >Register New Company</v-card-title
          >
          <v-form ref="form" v-model="valid" class="px-2">
            <!-- Company information Row -->
            <v-row>
              <v-col>
                <v-text-field
                  v-model="CompanyInfo.companyName"
                  validate-on-blur
                  :rules="[
                    v => !!v || 'Xawala Name is required',
                    checkCompanyName,
                  ]"
                  label="Xawala Name"
                  :append-icon="NameIcon"
                  color="success"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="CompanyInfo.phone"
                  :rules="[v => !!v || 'phone is require', checkCompanyPhone]"
                  label="Xawala Phone"
                  required
                  :append-icon="phoneICon"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="CompanyInfo.domain"
                  validate-on-blur
                  :rules="[v => !!v || 'Domai Name is required']"
                  label="Domain Name"
                  color="success"
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>

            <!-- Company Location Row -->
            <v-row>
              <v-col>
                <v-select
                  v-model="CompanyInfo.country"
                  :items="countries"
                  :rules="[v => !!v || 'Country is required']"
                  label="Country"
                  required
                ></v-select>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="CompanyInfo.City"
                  :rules="[v => !!v || 'City is require']"
                  label="City"
                  required
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="CompanyInfo.Address"
                  :rules="[v => !!v || 'Address is require']"
                  label="Address"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Manager information login info row -->
            <v-row>
              <v-col
                ><v-text-field
                  v-model="CompanyInfo.Owner"
                  :rules="[v => !!v || 'Owner Name is require']"
                  label="Manager Full Name"
                  required
                ></v-text-field
              ></v-col>
              <v-col
                ><v-text-field
                  v-model="CompanyInfo.OwnerPhone"
                  :rules="[v => !!v || 'Manager phone is require']"
                  label="Manager Phone"
                  required
                ></v-text-field
              ></v-col>
              <v-col>
                <v-text-field
                  v-model="CompanyInfo.UserName"
                  :rules="[v => !!v || 'User Name is require', checkUserName]"
                  label="UserName Name"
                  required
                  :append-icon="UserIcon"
                ></v-text-field
              ></v-col>
              <v-col>
                <v-text-field
                  v-model="CompanyInfo.Password"
                  :rules="[v => !!v || 'Password is require']"
                  label="Password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  required
                ></v-text-field
              ></v-col>
            </v-row>

            <!-- Store information Row -->
            <v-row>
              <v-col>
                <v-select
                  v-model="CompanyInfo.StoreCountry"
                  :items="countries"
                  :rules="[v => !!v || 'Store Country is required']"
                  label="Store Country"
                  required
                ></v-select>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="CompanyInfo.StoreCity"
                  :rules="[v => !!v || 'Store City is require']"
                  label="Store City"
                  required
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="CompanyInfo.StoreName"
                  :rules="[v => !!v || 'Store Name is require', checkStoreName]"
                  label="Store Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="CompanyInfo.StoreKeeper"
                  :rules="[v => !!v || 'Store keeper is required']"
                  label="Store keeper"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="msgErr" justify="center">
              <p v-html="msgErr" class="error--text title"></p>
            </v-row>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn
                :disabled="!valid"
                color="success"
                width="200"
                :loading="clicked"
                @click="OnSave"
              >
                Register
                <v-icon right>mdi-content-save-all</v-icon>
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    msgErr: null,
    clicked: false,
    valid: true,
    countries: ["Somali", "Kenya", "Dubai", "South Afric"],
    CompanyInfo: {
      // Company information
      companyName: "SABCO FOOD STUFFS",
      domain: "luulu.com",
      country: "Kenya",
      Address: "Estlight",
      City: "Nairobi",
      phone: "0705643795",
      // companyName: "",
      // domain: "",
      // country: "Kenya",
      // Address: null,
      // City: null,
      // phone: null,
      //   Manager information
      Owner: "Laila Ali Ahmed",
      OwnerPhone: "0705643795",
      //   User information
      UserName: "luulu",
      Password: "123456",
      // Store Information
      StoreCountry: "Kenya",
      StoreCity: "Nairobi",
      StoreName: "Main Store",
      StoreKeeper: "Abdullahi Abas",
    },
    existingInfo: {
      comName: false,
      storeName: false,
      phone: false,
      user: false,
      houseName: false,
    },
    showPassword: false,
    NameIcon: null,
    storeIcon: null,
    phoneICon: null,
    UserIcon: null,
  }),

  methods: {
    checkCompanyName(v) {
      if (this.existingInfo.comName) {
        this.existingInfo.comName = false;
        this.NameIcon = "fas fa-times";
        return `${v} is already taken`;
      } else {
        this.NameIcon = "fas fa-check";
        return true;
      }
    },
    checkStoreName(v) {
      if (this.existingInfo.storeName) {
        this.existingInfo.storeName = false;
        this.storeIcon = "fas fa-times";
        return `${v} is already taken`;
      } else {
        this.storeIcon = "fas fa-check";
        return true;
      }
    },
    checkCompanyPhone(v) {
      if (this.existingInfo.phone) {
        this.existingInfo.phone = false;
        this.UserIcon = "fas fa-times";
        return `${v} is already registred`;
      } else {
        this.UserIcon = "fas fa-check";
        return true;
      }
    },
    checkUserName(v) {
      if (this.existingInfo.user) {
        this.existingInfo.user = false;
        this.phoneICon = "fas fa-times";
        return `${v} is already taken`;
      } else {
        this.phoneICon = "fas fa-check";
        return true;
      }
    },
    OnSave() {
      this.msgErr = null;
      if (this.$refs.form.validate()) {
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/Accounts/kurid",
            data: this.CompanyInfo,
          })
          .then(result => {
            console.log(result);
            this.clicked = false;
            this.reset();
          })
          .catch(err => {
            this.clicked = false;
            if (err.response.status === 409) {
              // console.log(err.response.data);
              this.existingInfo.comName = err.response.data.companyName;
              this.existingInfo.storeName = err.response.data.storeName;
              this.existingInfo.phone = err.response.data.phone;
              this.existingInfo.user = err.response.data.UserName;
              // this.existingInfo.houseName = err.response.data.HouseName;
              this.$refs.form.validate();
            } else this.msgErr = err.response.data;
          });

        // console.log(this.CompanyInfo);
        // this.reset();
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>
